export default __webpack_public_path__ + "static/media/DSC_9216-edited.14295d8e.jpg";